import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SpinnerModule } from 'src/app/common/spinner/spinner.module';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { CourseCardModule } from 'src/app/common/course-card/course-card.module';
import { MatButtonModule } from '@angular/material/button';
import { SlideshowModule } from 'ng-simple-slideshow';
import { CourseGridModule } from 'src/app/common/course-grid/course-grid.module';
import { MatIconModule } from '@angular/material/icon';
import { TeacherCardModule } from 'src/app/common/teacher-card/teacher-card.module';
import { MatDividerModule } from '@angular/material/divider';
import { CarouselModule } from 'ng-carousel-cdk';
import { CourseCarouselModule } from 'src/app/common/course-carousel/course-carousel.module';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SpinnerModule,
    MatCardModule,
    MatTabsModule,
    CourseCardModule,
    MatButtonModule,
    SlideshowModule,
    CourseGridModule,
    MatIconModule,
    TeacherCardModule,
    MatDividerModule,
    CarouselModule,
    CourseCarouselModule
  ],
})

export class HomeModule { }
